import { InfoCircleOutlined } from '@ant-design/icons'
import { Tooltip } from 'antd'
import { CSSProperties, ReactNode } from 'react'

interface Props {
  title: ReactNode
  style?: CSSProperties
}

/**
 * The (i) icon of a tile: keyboard focusable, and named after the tooltip text
 * so a screen reader reads the definition (antd's Tooltip opens on focus).
 */
const InfoTip = ({ title, style }: Props) => (
  <Tooltip title={title}>
    <InfoCircleOutlined
      tabIndex={0}
      role="img"
      aria-label={typeof title === 'string' ? title : 'More information'}
      style={style}
    />
  </Tooltip>
)

export default InfoTip
